import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';
import { SectionEditComponent } from '../section-edit/section-edit.component';

@Component({
  selector: 'app-section-details',
  templateUrl: './section-details.component.html',
  styleUrls: ['./section-details.component.css']
})
export class SectionDetailsComponent implements OnInit {
  accId: any;
  templateId: any;
  rows: any[] = [];
  // templateData: any;
  templateData: any = []
  selectedItem: any;
  tempName: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: number, private accountService: AccountService, private dialog: MatDialog,
  private dialogRef: MatDialogRef<any>,
  ) { }

  ngOnInit(): void {
    this.accId = this.data['accountId'];
    this.templateId = this.data['templateId'];
    this.tempName = this.data['tempName'];
    if (this.accId) {
      this.getTemplateDetails(this.accId, this.templateId);
    }
  }
  getTemplateDetails(id, tempId) {
    this.accountService.getSectionDetails(id, tempId)
      .subscribe(res => {
        this.templateData = res;
        this.rows = this.chunkArray(this.templateData, 4);
      });
  }
  chunkArray(array: any[], size: number): any[] {
    const chunkedArray = [];
    for (let i = 0; i < array.length; i += size) {
      chunkedArray.push(array.slice(i, i + size));
    }
    return chunkedArray;
  }
  changeSection(templateDetail: any) {
    // this.dialogRef.close();
    this.selectedItem = templateDetail;
    const dialogRef = this.dialog.open(SectionEditComponent, {
      width: '800px',
      height: '700px',
      data: {
        'accountId': this.accId, 'templatedetailId': templateDetail.id, 'type' : 'edit','tempId' : this.templateId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  createNewSection() {
    const dialogRef = this.dialog.open(SectionEditComponent, {
      width: '800px',
      height: '700px',
      data: {
        'accountId': this.accId, 'type' : 'add', 'tempId' : this.templateId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getTemplateDetails(this.accId, this.templateId);
    });
  }
  
}
